var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import RcImage from 'rc-image';
import { OutlinedClose, OutlinedLeft, OutlinedRight, OutlinedZoomIn, OutlinedZoomOut, OutlinedRefresh, OutlinedSwap, } from 'acud-icon';
import { ConfigContext } from '../config-provider';
import { getTransitionName } from '../_util/motion';
export const icons = {
    // 左右旋转的图标没有找到类似的及特别合适的，先用下面这个
    rotateLeft: <OutlinedRefresh style={{ transform: 'scaleX(-1)' }}/>,
    rotateRight: <OutlinedRefresh />,
    zoomIn: <OutlinedZoomIn />,
    zoomOut: <OutlinedZoomOut />,
    flipX: <OutlinedSwap />,
    flipY: <OutlinedSwap rotate={90}/>,
    close: <OutlinedClose />,
    left: <OutlinedLeft />,
    right: <OutlinedRight />,
};
const InternalPreviewGroup = (_a) => {
    var { previewPrefixCls: customizePrefixCls, preview } = _a, props = __rest(_a, ["previewPrefixCls", "preview"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('image-preview', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedPreview = React.useMemo(() => {
        if (preview === false) {
            return preview;
        }
        const realPreview = typeof preview === 'object' ? preview : {};
        return Object.assign(Object.assign({}, realPreview), { transitionName: getTransitionName(rootPrefixCls, 'zoom', realPreview.transitionName), maskTransitionName: getTransitionName(rootPrefixCls, 'fade', realPreview.maskTransitionName) });
    }, [preview, rootPrefixCls]);
    return (<RcImage.PreviewGroup preview={mergedPreview} previewPrefixCls={prefixCls} icons={icons} {...props}/>);
};
export default InternalPreviewGroup;
